import React from 'react';
import { makeStyles} from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import { Box, InputBase, Grid, Paper, Typography, TextField, TableBody, TableRow, TableCell, Button, IconButton } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    search: {
    
        marginTop: '35px',
        position: 'relative',
        marginLeft: 0,
        width: '100%',
     
   
      },
      searchIcon: {
        float: 'left',
        height: '36px',
        color:'#DC251A',
        backgroungColor:'#FCFCFC',
        borderRadius: '1px',
     
        maxHeight: '39px',
      
      },
      inputRoot: {
        float: 'left',
        borderRadius: '1px',
        minWidth: '30%',
        height: '36px',
        color: '#333333',
        backgroundColor: '#F0F0F0',
        fontFamily: 'Montserrat',
        fontWeight: 600,
        fontSize: '15px',
        "& input::placeholder": {
          fontSize: "15px",
          color: '#333333',
          fontWeight: 500
        }
        
      },
      inputInput: {
        padding: 10,
        maxWidth: '700px',
        maxHeight: '41px',
        top: '242px',
        right: '500px',
        
      },
}));

const Searchbar = ({handleChange, searchFieldValue, setSearchParam, searchParam}) => {
    const classes = useStyles();
    return(
        <div>
        <Box className={classes.search}>
        <InputBase
        placeholder="Search by keyword"
        onChange={(e) => {if(handleChange){handleChange(e)}else if(setSearchParam){
          setSearchParam({...searchParam, searchFieldValue: e.currentTarget.value})
        }}}
        value={searchFieldValue}
        classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
        }}
        
        inputProps={{ 'aria-label': 'search' }}
        />
        <IconButton className={classes.searchIcon} type="submit" aria-label="search" style={{backgroundColor:'white', border: '1px solid #F0F0F0', width: '40px'}}>
            <SearchIcon />
        </IconButton>
        </Box>
        </div>
    )
}

export default Searchbar;
